module.exports = __webpack_public_path__ + "img/gems.05b0de38.jpg";